import { cssRoot } from "@axisnode/design-tokens";
import { useEffect, type ReactNode } from "react";

const STYLE_ID = "axisnode-design-tokens-root";

/** Injects design-tokens' `:root` CSS custom properties once per document. */
export function TokensRoot({ children }: { children: ReactNode }) {
  useEffect(() => {
    if (typeof document === "undefined") return;
    let el = document.getElementById(STYLE_ID) as HTMLStyleElement | null;
    if (!el) {
      el = document.createElement("style");
      el.id = STYLE_ID;
      document.head.appendChild(el);
    }
    el.textContent = cssRoot;
  }, []);
  return <>{children}</>;
}
